import React, { useEffect, useMemo, useRef } from 'react';
import { useUser } from '../../../redux/reducer/user';
import { image } from '../../../utils/data/baseUrl';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { setShowMessage, useContent } from '../../../redux/reducer/content';
import { useTranslation } from '../../../translations';

const MyId = React.forwardRef(function MyId(props, ref) {
  const { id, className, simpleStyle } = props;
  const dispatch = useDispatch();
  const { showMessage } = useContent();
  const { profile } = useUser();
  const uid = profile?.uid;
  const idRef = useRef();
  const text = id || uid + '';
  const fS = text.length > 8 ? 8 / text.length : 1;
  const { t } = useTranslation();

  useEffect(() => {
    if (showMessage) {
      const t = setTimeout(() => dispatch(setShowMessage(false)), 3000);
      return () => clearTimeout(t);
    }
  }, [showMessage]);

  const copyIDToClipboard = () => {
    if (idRef.current) {
      const idText = idRef.current.innerText.slice(2);
      navigator?.clipboard?.writeText?.(idText)?.then?.(() => {
        dispatch(setShowMessage(t('other.idCopied')));
      });
    }
  };

  const _style = useMemo(() => {
    return simpleStyle ? {} : { fontSize: `${fS}em`, lineHeight: `${fS}em` };
  }, [simpleStyle, fS]);

  return (
    <div
      className={classNames('my-id', className, {
        'my-id_simple-style': simpleStyle,
      })}
      onClick={copyIDToClipboard}
    >
      <span style={_style} ref={idRef}>
        id{id || uid}
      </span>
      {!simpleStyle && <img src={image('info.svg')} alt={''} />}
    </div>
  );
});

export default MyId;
MyId.propTypes = {};
